import { useState, useMemo } from "react";
import TransactionDetails from "./TransactionDetails";
import DataTable from "../../components/common/DataTable";

const transactions = [
  { id: "PAY-20260402122929-MD82Y9", date: "Apr 02, 2026 • 12:29 PM", baseAmount: "1.0000 USD", commission: "0.2000 USD", grossTotal: "1.2000 USD", status: "REFUNDED", serviceType: "Payout", ip: "72.61.243.189", idRef: "e589a293-8b86-4aaa...", netTotal: "1.2000 USD", grossAmount: "1.0000 USD", serviceCommission: "+ 0.2000 USD" },
  { id: "PAY-20260402122747-ZA2Y5S", date: "Apr 02, 2026 • 12:27 PM", baseAmount: "1005.0000 USD", commission: "31.5000 USD", grossTotal: "1039.5000 USD", status: "SUCCESS", serviceType: "Payout", ip: "192.168.1.10", idRef: "a1b2c3d4-1234-5678...", netTotal: "1039.5000 USD", grossAmount: "1005.0000 USD", serviceCommission: "+ 31.5000 USD" },
  { id: "PAY-20260402122346-WNY2MC", date: "Apr 02, 2026 • 12:23 PM", baseAmount: "1010.0000 USD", commission: "252.5000 USD", grossTotal: "1262.5000 USD", status: "SUCCESS", serviceType: "Payout", ip: "10.0.0.55", idRef: "f7e6d5c4-abcd-ef01...", netTotal: "1262.5000 USD", grossAmount: "1010.0000 USD", serviceCommission: "+ 252.5000 USD" },
  { id: "PAY-20260402122309-BEAC0", date: "Apr 02, 2026 • 12:23 PM", baseAmount: "11.0000 USD", commission: "2.2000 USD", grossTotal: "13.2000 USD", status: "REFUNDED", serviceType: "Payout", ip: "203.0.113.42", idRef: "c9d8e7f6-5678-1234...", netTotal: "13.2000 USD", grossAmount: "11.0000 USD", serviceCommission: "+ 2.2000 USD" },
  { id: "PAY-20260402122048-USW4SZ", date: "Apr 02, 2026 • 12:10 PM", baseAmount: "11.0000 USD", commission: "2.2000 USD", grossTotal: "13.2000 USD", status: "REFUNDED", serviceType: "Payout", ip: "198.51.100.7", idRef: "b3a2c1d0-9101-1121...", netTotal: "13.2000 USD", grossAmount: "11.0000 USD", serviceCommission: "+ 2.2000 USD" },
];

function StatusBadge({ status }) {
  const styles = { SUCCESS: "bg-emerald-100 text-emerald-700 border border-emerald-200", REFUNDED: "bg-red-100 text-red-600 border border-red-200" };
  return <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full tracking-wider ${styles[status] || "bg-gray-100 text-gray-500"}`}>{status}</span>;
}

function QuickViewModal({ tx, onClose }) {
  return (<>
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm animate-fade-in">
        <div className="flex items-center justify-between p-5 pb-3 border-b border-gray-100">
          <p className="text-xs font-mono font-bold text-gray-600 truncate pr-2">{tx.id}</p>
          <button onClick={onClose} className="p-1.5 rounded-lg border-none bg-transparent cursor-pointer hover:bg-gray-100 text-gray-400 flex-shrink-0">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>
        <div className="p-5 space-y-3">
          <div className="flex justify-between text-sm"><span className="text-gray-400">Status</span><StatusBadge status={tx.status} /></div>
          <div className="flex justify-between text-sm"><span className="text-gray-400">Base Amount</span><span className="font-semibold text-gray-800">{tx.baseAmount}</span></div>
          <div className="flex justify-between text-sm"><span className="text-gray-400">Commission</span><span className="font-semibold text-red-500">{tx.commission}</span></div>
          <div className="flex justify-between items-end border-t border-dashed border-gray-200 pt-3">
            <span className="font-bold text-gray-800">Gross Total</span>
            <span className="font-black text-violet-700 text-lg">{tx.grossTotal}</span>
          </div>
        </div>
      </div>
    </div>
  </>);
}

export default function TransactionLedger() {
  const [tab, setTab] = useState("realtime");
  const [quickView, setQuickView] = useState(null);
  const [detailsTx, setDetailsTx] = useState(null);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1, total: 0 });

  const columns = useMemo(() => [
    {
      accessorKey: 'id',
      header: 'Transaction Reference',
      size: 300,
      Cell: ({ row }) => (
        <div className="flex items-center gap-3">
          <div className={`w-7 h-7 rounded-full flex items-center justify-center text-white text-xs font-bold flex-shrink-0 ${row.original.status === "SUCCESS" ? "bg-emerald-400" : "bg-red-400"}`}>
            {row.original.status === "SUCCESS" ? "✓" : "↩"}
          </div>
          <div>
            <p className="font-mono text-xs font-semibold text-gray-700">{row.original.id}</p>
            <p className="text-[10px] text-gray-400">{row.original.date}</p>
          </div>
        </div>
      )
    },
    {
      accessorKey: 'baseAmount',
      header: 'Base Amount',
      size: 150,
      Cell: ({ row }) => <span className="font-semibold text-gray-700 text-xs">{row.original.baseAmount}</span>
    },
    {
      accessorKey: 'commission',
      header: 'Commission',
      size: 150,
      Cell: ({ row }) => <span className="text-gray-500 text-xs">{row.original.commission}</span>
    },
    {
      accessorKey: 'grossTotal',
      header: 'Gross Total',
      size: 150,
      Cell: ({ row }) => <span className="font-bold text-gray-800 text-xs">{row.original.grossTotal}</span>
    },
    {
      accessorKey: 'status',
      header: 'Network Status',
      size: 150,
      Cell: ({ row }) => <StatusBadge status={row.original.status} />
    },
    {
      accessorKey: 'actions',
      header: 'Actions',
      size: 120,
      Cell: ({ row }) => (
        <div className="flex items-center gap-1">
          <button
            onClick={() => setQuickView(row.original)}
            title="Quick View"
            className="p-1.5 rounded-lg border-none bg-transparent cursor-pointer hover:bg-violet-100 text-gray-400 hover:text-violet-600 transition"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </button>
          <button
            onClick={() => setDetailsTx(row.original)}
            title="View Full Details"
            className="p-1.5 rounded-lg border-none bg-transparent cursor-pointer hover:bg-violet-100 text-gray-400 hover:text-violet-600 transition"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>
        </div>
      )
    }
  ], []);

  if (detailsTx) {
    return (
      <div className="flex h-screen overflow-hidden bg-gray-50" style={{ fontFamily: "'DM Sans', sans-serif" }}>
        <div className="flex-1 flex flex-col overflow-hidden">
          <TransactionDetails tx={detailsTx} onBack={() => setDetailsTx(null)} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        
        <div className="flex-1 overflow-y-auto p-6">
          <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Playfair+Display:wght@700&display=swap" rel="stylesheet" />
          <style>{`
            @keyframes fade-in { from { opacity:0; transform:scale(0.97) translateY(6px); } to { opacity:1; transform:scale(1) translateY(0); } }
            .animate-fade-in { animation: fade-in 0.18s ease-out; }
          `}</style>
          
          <div className="space-y-4">
            
            <div className="flex items-center justify-between mb-1">
              <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', serif" }}>Transaction Ledger</h1>
              <div className="flex bg-white border border-gray-200 rounded-lg overflow-hidden text-xs font-semibold">
                <button onClick={() => setTab("realtime")} className={`px-4 bg-transparent border-none py-2 cursor-pointer transition ${tab === "realtime" ? "bg-violet-600 text-white" : "text-gray-500 hover:bg-gray-50"}`}>Real-time</button>
                <button onClick={() => setTab("archived")} className={`px-4 bg-transparent border-none py-2 cursor-pointer transition ${tab === "archived" ? "bg-violet-600 text-white" : "text-gray-500 hover:bg-gray-50"}`}>Archived</button>
              </div>
            </div>
            <p className="text-xs text-gray-400 mb-6">Monitoring financial movement across your Kresta Pay accounts</p>

            <div className="grid grid-cols-4 gap-4 mb-6">
              <div className="bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
                <p className="text-xs text-gray-400 mb-1 uppercase tracking-wider font-semibold">Total Volume</p>
                <p className="text-2xl font-bold text-gray-900">2,341.20</p>
                <p className="text-[11px] text-emerald-500 font-semibold mt-1">↑ +12.4% from last month</p>
              </div>
              <div className="bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
                <p className="text-xs text-gray-400 mb-1 uppercase tracking-wider font-semibold">Successful</p>
                <p className="text-2xl font-bold text-gray-900">248</p>
                <p className="text-[11px] text-gray-400 mt-1">☑ 84% approval rate</p>
              </div>
              <div className="bg-white rounded-xl p-4 border border-gray-100 shadow-sm">
                <p className="text-xs text-gray-400 mb-1 uppercase tracking-wider font-semibold">Fees Accrued</p>
                <p className="text-2xl font-bold text-gray-900">308.40</p>
              </div>
              <div className="bg-violet-700 rounded-xl p-4 shadow-sm flex flex-col justify-between">
                <p className="text-[10px] text-violet-200 uppercase tracking-widest font-bold">Settlement Status</p>
                <p className="text-xl font-bold text-white mt-2">All Clear</p>
              </div>
            </div>

            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden pb-4">
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
                <h2 className="font-bold text-gray-800">System Ledger</h2>
                <div className="flex gap-2">
                  <button className="flex items-center gap-1.5 text-xs text-gray-500 bg-transparent border border-gray-200 rounded-lg cursor-pointer px-3 py-1.5 hover:bg-gray-50 transition font-semibold">
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" /></svg>
                    Filter
                  </button>
                  <button className="flex items-center gap-1.5 text-xs text-gray-500 bg-transparent border border-gray-200 rounded-lg cursor-pointer px-3 py-1.5 hover:bg-gray-50 transition font-semibold">
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /></svg>
                    Export CSV
                  </button>
                </div>
              </div>

              <div>
                <DataTable columns={columns} data={transactions} />
              </div>
            </div>

          </div>
        </div>

        {quickView && <QuickViewModal tx={quickView} onClose={() => setQuickView(null)} />}
      </div>
    </div>
  );
}
